module.exports = __webpack_public_path__ + "static/media/cf.667c7a42.svg";